import angular from 'angular';
import ESignSupportingDocuments from './eSignSupportingDocuments';

export default angular
  .module('components.eSignSupportingDocuments', [])
  .component('eSignSupportingDocuments', ESignSupportingDocuments).name;
